import { Avatar } from "@material-ui/core";
import React from "react";
import "./card.css";
import TextTruncate from "react-text-truncate";
import { ConvertView,ConvertDate } from "../../helper/math";
import {Link} from 'react-router-dom';

function Card({ src,id, channelTime, channelName, channelView, description,detail ,videoDetail,image}) {
 
  return (
    <div className="card">
      <div  className="card__image">
        <Link to={`/watch?v=${id}`} onClick={() => videoDetail(detail)} ><img src={src} alt="" /></Link>
      </div>
      <div className="card__bottom">
        <div className="card__bottomAvatar">
          <Avatar src={image} />
        </div>
        <Link  to={`/watch?v=${id}`} onClick={() => videoDetail(detail)} className="card__bottomText">
          <TextTruncate
            element="h4"
            line={2}
            truncateText="..."
            text={description}
          />
          <span className="card__channelName">
            {channelName}
          </span>
          <br />
          <span className="card__channelView">
            {ConvertView(channelView)} .
          </span>
          <span className="card__channelTime">{ConvertDate(channelTime)}</span>
        </Link>
      </div>
    </div>
  );
}

export default Card;
